import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  handleFetchAppslistData,
  handleSaveAppslistData,
  handlePostAppslistData,
  handleDeleteAppslistData,
} from './appslist.helpers';
import {
  fetchAppslistDataSuccess,
  fetchAppslistDataFailure,
  saveAppslistDataSuccess,
  saveAppslistDataFailure,
  postAppslistDataSuccess,
  postAppslistDataFailure,
  deleteAppslistDataSuccess,
  deleteAppslistDataFailure,
  makeIsFetchingTrue,
} from './appslist.actions';
import { appslistTypes } from './appslist.types';
import { handleErrors, getNotifMsg } from 'utils';
import { toast } from 'react-toastify';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchAppslistDataSaga() {
  try {
    yield put(makeIsFetchingTrue());
    const response = yield call(handleFetchAppslistData);
    yield put(fetchAppslistDataSuccess(response));
  } catch (error) {
    yield put(fetchAppslistDataFailure(error));
    handleErrors(error);
  }
}

export function* saveAppslistDataSaga({ payload }) {
  const { locale } = yield select(mapState);
  const { appID, enabled } = payload;

  try {
    yield put(makeIsFetchingTrue());
    const response = yield call(handleSaveAppslistData(appID, enabled));
    yield put(saveAppslistDataSuccess(response));
    yield put({ type: appslistTypes.FETCH_APPS_LIST_DATA });

    if (response.success) {
      toast.success(getNotifMsg('REQUEST_SUBMITED_SUCCESS', locale));
    }
  } catch (error) {
    yield put(saveAppslistDataFailure(error));
    handleErrors(error);
  }
}

export function* postAppslistDataSaga(action) {
  const { locale } = yield select(mapState);
  try {
    yield put(makeIsFetchingTrue());
    const response = yield call(handlePostAppslistData, action.payload);
    if (response.success) {
      yield put(postAppslistDataSuccess(response));
      yield put({ type: appslistTypes.FETCH_APPS_LIST_DATA });

      return toast.success(getNotifMsg('REQUEST_ADD_APP_SUCCESS', locale));
    }
    yield put(postAppslistDataFailure(response));
    toast.error(getNotifMsg('REQUEST_ADD_APP_FAILURE', locale));
  } catch (error) {
    yield put(postAppslistDataFailure(error));
    handleErrors(error);
  }
}

export function* deleteAppslistDataSaga({ payload }) {
  const { locale } = yield select(mapState);
  const { appID } = payload;
  try {
    yield put(makeIsFetchingTrue());
    const response = yield handleDeleteAppslistData(appID);
    yield put(deleteAppslistDataSuccess(response));
    yield put({ type: appslistTypes.FETCH_APPS_LIST_DATA });

    if (response.success) {
      toast.success(getNotifMsg('REQUEST_DELETE_APP_SUCCESS', locale));
    }
  } catch (error) {
    yield put(deleteAppslistDataFailure(error));
    handleErrors(error);
  }
}

export function* onFetchingAppslistData() {
  yield takeLatest(appslistTypes.FETCH_APPS_LIST_DATA, fetchAppslistDataSaga);
}

export function* onSavingAppslistData() {
  yield takeLatest(appslistTypes.SAVE_APPS_LIST_DATA, saveAppslistDataSaga);
}

export function* onPostingAppslistData() {
  yield takeLatest(appslistTypes.POST_APPS_LIST_DATA, postAppslistDataSaga);
}

export function* onDeletingAppslistData() {
  yield takeLatest(appslistTypes.DELETE_APPS_LIST_DATA, deleteAppslistDataSaga);
}

export default function* appslistSaga() {
  yield all([
    call(onFetchingAppslistData),
    call(onSavingAppslistData),
    call(onPostingAppslistData),
    call(onDeletingAppslistData),
  ]);
}
